import { useTranslation } from 'react-i18next';

import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import RoundedInput from 'components/desktop/_general/Input/RoundedInput/RoundedInput';
import { Characteristic } from 'enums/characteristic';
import ENTITLEMENTS from 'enums/entitlements';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';
import useCurrency from 'hooks/redux/useCurrency';

export const IngredientCostCard = ({ state, handlers }: IngredientTabProps): JSX.Element => {
	const { t } = useTranslation();
	const reduxCurrency: string = useCurrency();

	const isIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEINGREDIENT,
	]);

	const getLabel = (): string => {
		if (state.characteristic == Characteristic.Fluid) {
			return `${reduxCurrency} ${t('_general:PER')} 100ml`;
		} else {
			return `${reduxCurrency} ${t('_general:PER')} 100g`;
		}
	};

	return (
		<RenderIf entitlements={[ENTITLEMENTS.PRICE]}>
			<FoldableCard
				defaultOpen={true}
				dataComponentType="ingredient-costs-card"
				title={t('_general:COSTS')}
				content={
					<>
						<div className="card-body">
							<label>{getLabel()}</label>
							<RoundedInput
								disabled={!isIngredientEditor}
								error-key="Price"
								handleChange={handlers.setPrice}
								name="price"
								value={state.price ?? 0}
							/>
						</div>
					</>
				}
			/>
		</RenderIf>
	);
};
